import { useTheme, useMediaQuery } from "@mui/material";

export const useScreenWidth = (input) => {
  const theme = useTheme();
  const isMediaQuery = useMediaQuery(theme.breakpoints.up(input ? input : "md"));

  return isMediaQuery;
}